export default "/images/73c2f6ac4fa20e50037b952f9cbc421f.png";